// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6e997c98","239":"cb1a2ee6","455":"bc6fd41f"}[chunkId] + ".chunk.js";
};